import { AddBuyMemberForm } from '../../subrouters/Members/pages/Members/components/AddGroupMember/components/SingleAddMember/SingleAddMember.component';
import httpClient from '../httpClient';
import {
  DataRoomMember,
  DataRoomMembers,
} from 'router/subrouters/DataRoom/models/DataRoomMember';

function getMembers(dataRoomId: string) {
  return httpClient.get<DataRoomMembers>(
    `data-room-members/data-rooms/${dataRoomId}`,
  );
}

function updateMember(memberId: string, data: Partial<DataRoomMember>) {
  return httpClient.patch<DataRoomMembers>(
    `data-room-members/${memberId}`,
    data,
  );
}

function removeMember(memberId: string) {
  return httpClient.delete<DataRoomMembers>(`data-room-members/${memberId}`);
}

function addMember(dataRoomId: string, data: AddBuyMemberForm) {
  return httpClient.post<DataRoomMembers>(
    `data-room-members/data-rooms/${dataRoomId}/invite-buy-side-members`,
    data,
  );
}

function deleteGroup(groupId: string) {
  return httpClient.delete<DataRoomMembers>(
    `data-room-buy-side-groups/${groupId}`,
  );
}

function revokeAccessGroup(groupId: string) {
  return httpClient.post(
    `data-room-buy-side-groups/${groupId}/revoke-files-access`,
  );
}

function undoRevokeAccessGroup(groupId: string) {
  return httpClient.post(
    `data-room-buy-side-groups/${groupId}/undo-revoke-files-access`,
  );
}

function inviteSellSideMembers(
  dataRoomId: string,
  data: { sellSideMembers: string[]; teamNames?: string[] },
) {
  return httpClient.post<DataRoomMembers>(
    `data-room-members/data-rooms/${dataRoomId}/invite-members`,
    data,
  );
}

function createBuySideGroup(
  dataRoomId: string,
  data: { name: string; buySideGroupMembers: string[] },
) {
  return httpClient.post<DataRoomMembers>(
    `data-room-buy-side-groups/data-rooms/${dataRoomId}`,
    data,
  );
}

function updateBuySideGroup(
  dataRoomBuySideGroupId: string,
  data: {
    name?: string;
    buySideGroupMembers?: string[];
    autoApproveQuestions?: boolean;
  },
) {
  return httpClient.patch<DataRoomMembers>(
    `data-room-buy-side-groups/${dataRoomBuySideGroupId}`,
    data,
  );
}

function mergeBuySideGroups(
  dataRoomId: string,
  data: { buySideGroupName: string; buySideGroupIds: string[] },
) {
  return httpClient.post<DataRoomMembers>(
    `data-room-buy-side-groups/data-rooms/${dataRoomId}/merge`,
    data,
  );
}

function updateBuySideGroupAllQuestionsApprove(dataRoomBuySideGroupId: string) {
  return httpClient.post(
    `data-room-buy-side-groups/${dataRoomBuySideGroupId}/approve-all-questions`,
  );
}

function notifyBuySideMember(buySideId: string) {
  return httpClient.post<DataRoomMembers>(
    `data-room-members/${buySideId}/send-reminder`,
  );
}

function acceptRequest(dataRoomId: string, data: Partial<DataRoomMember>) {
  return httpClient.post<DataRoomMember>(
    `data-room-members/${dataRoomId}/approve-access-request`,
    data,
  );
}

function declineRequest(dataRoomId: string) {
  return httpClient.post(
    `data-room-members/${dataRoomId}/decline-access-request`,
  );
}

function requestAccess(dataRoomId: string) {
  return httpClient.post(
    `data-room-members/data-rooms/${dataRoomId}/request-access`,
  );
}

function revokeAccess(memberId: string) {
  return httpClient.post(`data-room-members/${memberId}/revoke-files-access`);
}

function undoRevokeAccess(memberId: string) {
  return httpClient.post(
    `data-room-members/${memberId}/undo-revoke-files-access`,
  );
}

function inviteBuySideMember(
  buySideGroupId: string,
  data: Partial<DataRoomMember>,
) {
  return httpClient.post<DataRoomMembers>(
    `data-room-buy-side-groups/${buySideGroupId}/invite-buy-side-member`,
    data,
  );
}

function keepFileAccess(memberId: string) {
  return httpClient.post(`data-room-members/${memberId}/keep-data-room-access`);
}

function undoKeepFileAccess(memberId: string) {
  return httpClient.post(
    `data-room-members/${memberId}/undo-keep-data-room-access`,
  );
}

function removeFileAccess(memberId: string) {
  return httpClient.post(
    `data-room-members/${memberId}/remove-data-room-access`,
  );
}

function undoRemoveFileAccess(memberId: string) {
  return httpClient.post(
    `data-room-members/${memberId}/undo-remove-data-room-access`,
  );
}

function revokeAccessForNode(memberId: string, nodeId: string) {
  return httpClient.post(
    `data-room-members/${memberId}/data-room-nodes/${nodeId}/revoke-files-access`,
  );
}

function undoRevokeAccessForNode(memberId: string, nodeId: string) {
  return httpClient.post(
    `data-room-members/${memberId}/data-room-nodes/${nodeId}/undo-revoke-files-access`,
  );
}

function extendFileAccess(dataRoomId: string) {
  return httpClient.post<DataRoomMember>(
    `data-room-members/data-rooms/${dataRoomId}/extend-file-access`,
  );
}

export default {
  getMembers,
  updateMember,
  removeMember,
  addMember,
  inviteSellSideMembers,
  createBuySideGroup,
  deleteGroup,
  notifyBuySideMember,
  acceptRequest,
  declineRequest,
  requestAccess,
  updateBuySideGroup,
  updateBuySideGroupAllQuestionsApprove,
  revokeAccessGroup,
  undoRevokeAccessGroup,
  revokeAccess,
  undoRevokeAccess,
  inviteBuySideMember,
  keepFileAccess,
  undoKeepFileAccess,
  removeFileAccess,
  undoRemoveFileAccess,
  revokeAccessForNode,
  undoRevokeAccessForNode,
  extendFileAccess,
  mergeBuySideGroups,
};
